import * as React from 'react'
import { cn } from '@/lib/utils'
import { VariantProps, cva } from 'class-variance-authority'

const headingVariants = cva('', {
  variants: {
    weight: {
      medium: 'font-medium',
      regular: 'font-normal'
    },
    size: {
      xl: 'text-xl',
      lg: 'text-lg',
      sm: 'text-sm',
      xs: 'text-xs'
    }
  },
  defaultVariants: {
    weight: 'regular'
  }
})

interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement>, VariantProps<typeof headingVariants> {}

const Heading = React.forwardRef<HTMLHeadingElement, HeadingProps>(({ className, weight, size, ...props }, ref) => {
  const commonAttributes = {
    ref: ref,
    className: cn(headingVariants({ weight, size }), className)
  }

  switch (size) {
    case 'xl': {
      return <h1 {...commonAttributes} {...props} />
    }
    case 'lg': {
      return <h2 {...commonAttributes} {...props} />
    }
    case 'sm': {
      return <h3 {...commonAttributes} {...props} />
    }
    case 'xs': {
      return <h4 {...commonAttributes} {...props} />
    }
    default: {
      return <h1 {...commonAttributes} {...props} />
    }
  }
})

export { Heading }
